<template>
  <VideoPlayer
    :class="[
      'video-player-box',
      { 'progress-interaction-none': !interactionProgress },
    ]"
    ref="videoPlayer"
    :options="{
      autoplay: autoplay,
      controls: true,
      language: 'en',
      controlBar: {
        pictureInPictureToggle: false,
      },
      sources: [
        {
          type: 'video/mp4',
          src: `${$baseUrl}video/${videoSource}.mp4`,
        },
      ],
    }"
    :playsinline="true"
    ><button v-if="icon" @click="$emit('changeModal')">
      <icon :data="pageIcons[icon]" class="close-icon" color="white"></icon>
    </button>
  </VideoPlayer>
</template>

<script setup>
import { onBeforeUnmount, onBeforeMount } from "vue";
import { VideoPlayer } from "@videojs-player/vue";
import { pageIcons } from "../../../plugins/page-icons";
import "video.js/dist/video-js.css";

defineProps({
  videoSource: String,
  icon: String,
  autoplay: {
    type: Boolean,
    default: true,
  },
  interactionProgress: {
    type: Boolean,
    default: true,
  },
});

onBeforeMount(() => {
  document.body.style.overflow = "hidden";
});

onBeforeUnmount(() => {
  document.body.style.overflow = "initial";
});
</script>

<style lang="scss" scoped>
.close-icon {
  min-height: 2.25rem;
  min-width: 2.25rem;
  z-index: 11;
  position: absolute;
  top: toRem(33);
  right: toRem(23);
}
</style>

<style lang="scss">
.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
  opacity: 1;
}
.video-js {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  // width: 95vw;
  // height: 95vh;
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100);
  margin: auto;
  &.progress-interaction-none {
    .vjs-progress-control,
    .vjs-volume-control {
      pointer-events: none;
    }
  }

  .vjs-big-play-button {
    display: none;
  }
  .vjs-control:focus:before,
  .vjs-control:hover:before,
  .vjs-control:focus {
    box-shadow: transparent;
    text-shadow: none;
  }
  .vjs-tech {
    background: rgb(25, 25, 25);
  }
  .vjs-control-bar {
    height: toRem(44);
    width: 80vw;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: toRem(37);
    left: 0;
    // width: calc(100% - 160px);
    margin: 0 auto;
    max-width: toRem(965);
    padding-right: 160px;
    background: rgba(51, 51, 51, 0.7);
    backdrop-filter: blur(5px);

    .mobile & {
      width: 90vw;
    }

    .vjs-time-control {
      display: flex;
      align-items: center;
      font-size: 14px;
      @include link-s;

      &.vjs-current-time {
        color: $primary-yellow;
      }

      &.vjs-time-divider {
        display: none;
      }
      &.vjs-duration {
        display: none;
      }
    }
    .vjs-playback-rate {
      display: none;
      order: 1;
    }
    .vjs-play-control {
      height: 38px;
      .vjs-icon-placeholder {
        display: flex;
        align-items: center;
        height: 100%;
        &::before {
          color: $primary-yellow;
          height: auto;
          position: initial;
        }
      }
    }
    .vjs-fullscreen-control {
      display: none;
    }
    .vjs-progress-control {
      .vjs-progress-holder {
        background-color: $scala-grigi-white;
        height: 1.5px;
        .vjs-load-progress {
          div {
            background: $scala-grigi-white;
          }
        }
        .vjs-play-progress {
          background: $primary-yellow;
          &::before {
            content: "";
          }
        }
      }
    }

    .vjs-volume-panel {
      position: absolute;
      right: 90px;
      width: 80px;

      &.vjs-volume-panel-horizontal {
        width: 80px;
        &.vjs-hover {
          width: 80px;
        }
      }

      .vjs-mute-control {
        .vjs-icon-placeholder {
          &::before {
            color: $primary-yellow;
          }
        }
      }

      .vjs-volume-control {
        width: 80px;
        opacity: 1;
        height: 100%;

        .vjs-volume-bar {
          min-width: 80px;
          height: 1.5px;
          .vjs-volume-level {
            width: 80px;
            height: 1.5px;
            &::before {
              top: -6px;
            }
          }
        }
      }
    }

    .vjs-button > .vjs-icon-placeholder:before {
      line-height: 1.5;
    }
  }
}
@media (max-width: 650px) {
  .video-js {
    .vjs-control-bar {
      // width: 200px;

      .vjs-time-control {
        &.vjs-duration {
          right: auto;
          left: 70px;
          &::before {
            content: "/";
          }
        }
      }
    }
    .vjs-progress-control {
      display: none;
    }
  }
}
</style>
